import _Reflect$construct from '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React from 'react';
import { createRoot } from 'react-dom/client';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import Vue from 'vue';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';

var _excluded$1 = ["component"],
  _excluded2 = ["component", "on"];
function ownKeys$2(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$2(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$2(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var VUE_COMPONENT_NAME = "vuera-internal-component-name";
var wrapReactChildren = function wrapReactChildren(createElement, children) {
  return createElement("vuera-internal-react-wrapper", {
    props: {
      component: function component() {
        return /*#__PURE__*/React.createElement("div", null, children);
      }
    }
  });
};
var VueContainer = /*#__PURE__*/function (_React$Component) {
  function VueContainer(props) {
    var _this;
    _classCallCheck(this, VueContainer);
    _this = _callSuper$1(this, VueContainer, [props]);

    /**
     * We have to track the current Vue component so that we can reliably catch updates to the
     * `component` prop.
     */
    _this.currentVueComponent = props.component;

    /**
     * Modify createVueInstance function to pass this binding correctly. Doing this in the
     * constructor to avoid instantiating functions in render.
     */
    var createVueInstance = _this.createVueInstance;
    var self = _this;
    _this.createVueInstance = function (element, component, prevComponent) {
      createVueInstance(element, self, component, prevComponent);
    };
    return _this;
  }
  _inherits(VueContainer, _React$Component);
  return _createClass(VueContainer, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var component = nextProps.component,
        props = _objectWithoutProperties(nextProps, _excluded$1);
      if (this.currentVueComponent !== component) {
        this.updateVueComponent(this.props.component, component);
      }
      /**
       * NOTE: we're not comparing this.props and nextProps here, because I didn't want to write a
       * function for deep object comparison. I don't know if this hurts performance a lot, maybe
       * we do need to compare those objects.
       */
      _Object$assign(this.vueInstance.$data, props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.vueInstance.$destroy();
    }

    /**
     * Creates and mounts the Vue instance.
     * NOTE: since we need to access the current instance of VueContainer, as well as the Vue instance
     * inside of the Vue constructor, we cannot bind this function to VueContainer, and we need to
     * pass VueContainer's binding explicitly.
     * @param {HTMLElement} targetElement - element to attact the Vue instance to
     * @param {ReactInstance} reactThisBinding - current instance of VueContainer
     */
  }, {
    key: "createVueInstance",
    value: function createVueInstance(targetElement, reactThisBinding) {
      var _reactThisBinding$pro = reactThisBinding.props,
        component = _reactThisBinding$pro.component,
        on = _reactThisBinding$pro.on,
        props = _objectWithoutProperties(_reactThisBinding$pro, _excluded2);

      // `this` refers to Vue instance in the constructor
      reactThisBinding.vueInstance = new Vue(_objectSpread$2(_objectSpread$2({
        el: targetElement,
        components: _defineProperty(_defineProperty({}, VUE_COMPONENT_NAME, component), "vuera-internal-react-wrapper", ReactWrapper),
        data: props
      }, config.vueInstanceOptions), {}, {
        render: function render(createElement) {
          return createElement(VUE_COMPONENT_NAME, {
            props: this.$data,
            on: on
          }, [wrapReactChildren(createElement, this.children)]);
        }
      }));
    }
  }, {
    key: "updateVueComponent",
    value: function updateVueComponent(prevComponent, nextComponent) {
      this.currentVueComponent = nextComponent;

      /**
       * Replace the component in the Vue instance and update it.
       */
      this.vueInstance.$options.components[VUE_COMPONENT_NAME] = nextComponent;
      this.vueInstance.$forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this.createVueInstance
      });
    }
  }]);
}(React.Component);

var _excluded = ["children", ""];
function ownKeys$1(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$1(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$1(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var makeReactContainer = function makeReactContainer(Component) {
  var _ReactInVue;
  return _ReactInVue = /*#__PURE__*/function (_React$Component) {
    function ReactInVue(props) {
      var _this;
      _classCallCheck(this, ReactInVue);
      _this = _callSuper(this, ReactInVue, [props]);

      /**
       * We create a stateful component in order to attach a ref on it. We will use that ref to
       * update component's state, which seems better than re-rendering the whole thing with
       * ReactDOM.
       */
      _this.state = _objectSpread$1({}, props);
      return _this;
    }
    _inherits(ReactInVue, _React$Component);
    return _createClass(ReactInVue, [{
      key: "wrapVueChildren",
      value: function wrapVueChildren(children) {
        return {
          render: function render(createElement) {
            return createElement("div", children);
          }
        };
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
          children = _this$state.children;
          _this$state[""];
          var rest = _objectWithoutProperties(_this$state, _excluded);
        var wrappedChildren = this.wrapVueChildren(children);
        return /*#__PURE__*/React.createElement(Component, rest, children && /*#__PURE__*/React.createElement(VueContainer, {
          component: wrappedChildren
        }));
      }
    }]);
  }(React.Component), _defineProperty(_ReactInVue, "displayName", "ReactInVue".concat(Component.displayName || Component.name || "Component")), _ReactInVue;
};
var ReactWrapper = {
  props: ["component", "passedProps"],
  render: function render(createElement) {
    return createElement("div", {
      ref: "react"
    });
  },
  methods: {
    mountReactComponent: function mountReactComponent(component) {
      var _this2 = this;
      var Component = makeReactContainer(component);
      var children = this.$slots["default"] !== undefined ? {
        children: this.$slots["default"]
      } : {};
      this.root = createRoot(this.$refs.react);
      this.root.render( /*#__PURE__*/React.createElement(Component, _extends({}, this.$props.passedProps, this.$attrs, this.$listeners, children, {
        ref: function ref(_ref) {
          return _this2.reactComponentRef = _ref;
        }
      })));
    }
  },
  mounted: function mounted() {
    this.mountReactComponent(this.$props.component);
  },
  beforeDestroy: function beforeDestroy() {
    this.root.unmount();
  },
  updated: function updated() {
    /**
     * AFAIK, this is the only way to update children. It doesn't seem to be possible to watch
     * `$slots` or `$children`.
     */
    if (this.reactComponentRef) {
      if (this.$slots["default"] !== undefined) {
        this.reactComponentRef.setState({
          children: this.$slots["default"]
        });
      } else {
        this.reactComponentRef.setState({
          children: null
        });
      }
    }
  },
  inheritAttrs: false,
  watch: {
    $attrs: {
      handler: function handler() {
        if (this.reactComponentRef) {
          this.reactComponentRef.setState(_objectSpread$1({}, this.$attrs));
        }
      },
      deep: true
    },
    "$props.component": {
      handler: function handler(newValue) {
        this.mountReactComponent(newValue);
      }
    },
    $listeners: {
      handler: function handler() {
        if (this.reactComponentRef) {
          this.reactComponentRef.setState(_objectSpread$1({}, this.$listeners));
        }
      },
      deep: true
    },
    "$props.passedProps": {
      handler: function handler() {
        if (this.reactComponentRef) {
          this.reactComponentRef.setState(_objectSpread$1({}, this.$props.passedProps));
        }
      },
      deep: true
    }
  }
};

function isReactComponent(component) {
  if (_typeof(component) === "object" && !isReactForwardReference(component)) {
    return false;
  }
  return !(typeof component === "function" && component.prototype && (component.prototype.constructor["super"] && component.prototype.constructor["super"].isVue || component.prototype instanceof Vue));
}
function isReactForwardReference(component) {
  return component.$$typeof && component.$$typeof.toString() === "Symbol(react.forward_ref)";
}

function VueResolver(component) {
  return {
    components: {
      ReactWrapper: ReactWrapper
    },
    props: ["passedProps"],
    inheritAttrs: false,
    render: function render(createElement) {
      return createElement("react-wrapper", {
        props: {
          component: component,
          passedProps: this.$props.passedProps
        },
        attrs: this.$attrs,
        on: this.$listeners
      }, this.$slots["default"]);
    }
  };
}

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * This mixin automatically wraps all React components into Vue.
 */
var VuePlugin = {
  // eslint-disable-next-line no-unused-vars
  install: function install(Vue, options) {
    /**
     * We define a custom merging strategy for the `components` field. This strategy really just
     * wraps all the React components while leaving Vue components as is.
     */
    var originalComponentsMergeStrategy = Vue.config.optionMergeStrategies.components;
    Vue.config.optionMergeStrategies.components = function (parent) {
      var _context, _context2;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var mergedValue = originalComponentsMergeStrategy.apply(void 0, _concatInstanceProperty(_context = [parent]).call(_context, args));
      var wrappedComponents = mergedValue ? _reduceInstanceProperty(_context2 = _Object$entries(mergedValue)).call(_context2, function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, k, isReactComponent(v) ? VueResolver(v) : v));
      }, {}) : mergedValue;
      return _Object$assign(mergedValue, wrappedComponents);
    };
    Vue.prototype.constructor.isVue = true;
  }
};

function ReactResolver(component) {
  return isReactComponent(component) ? component : function (props) {
    return /*#__PURE__*/React.createElement(VueContainer, _extends({}, props, {
      component: component
    }));
  };
}

/**
 * This function gets imported by the babel plugin. It wraps a suspected React element and, if it
 * isn't a valid React element, wraps it into a Vue container.
 */
function babelReactResolver(component, props, children) {
  return isReactComponent(component) ? /*#__PURE__*/React.createElement(component, props, children) : /*#__PURE__*/React.createElement(VueContainer, _Object$assign({
    component: component
  }, props), children);
}

function defaultConfig() {
  return {
    vueInstanceOptions: {}
  };
}
var config = defaultConfig();

export { VueResolver as ReactInVue, ReactWrapper, ReactResolver as VueInReact, VuePlugin, VueContainer as VueWrapper, babelReactResolver as __vueraReactResolver, config };
